/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Language } from '../../utils/types';
import useFetchLanguages from 'Query/useFetchLanguage';
import { useUserContext } from '../../components/Providers/UserContext';

interface LanguageSelectProps {
  onLanguageChange: (language: Language) => void;
  language?: Language;
  langView?: boolean;
  supportedLanguages?: string[];
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({
  onLanguageChange,
  language,
  langView,
  supportedLanguages,
}) => {
  const { userToken } = useUserContext();
  const { data: languageList = [] } = useFetchLanguages(userToken);
  const [selectedValue, setSelectedValue] = useState<string>('');

  useEffect(() => {
    if (languageList.length > 0) {
      // Ensure initial value is a valid option
      const validLanguage = languageList.find((lang) => lang.code === language?.code);
      setSelectedValue(validLanguage ? validLanguage.code : languageList[0].code);
    }
  }, [languageList, language]);

  const handleChange = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedValue(value);
    const selectedLanguage = languageList.find((lang) => lang.code === value);
    if (selectedLanguage) onLanguageChange(selectedLanguage);
  };

  const dropDownStyle = {
    minWidth: 120,
    margin: '16px 0 8px',
    '&.language-view': { width: '440px' },
  };

  return (
    <section className="textfield-custom">
      <Box className={langView ? 'language-view' : ''} sx={dropDownStyle}>
        <FormControl fullWidth>
          <Select value={selectedValue} onChange={handleChange} displayEmpty>
            {languageList.map((lang) => (
              <MenuItem
                key={lang.code}
                value={lang.code}
                disabled={supportedLanguages ? !supportedLanguages.includes(lang.code) : false}
              >
                {lang.language}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </section>
  );
};

export default LanguageSelect;

// import { useEffect, useState } from "react";

// import Box from "@mui/material/Box";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import { Language } from "../../utils/types";
// import useFetchLanguages from "Query/useFetchLanguage";
// import { useUserContext } from "../../components/Providers/UserContext";

// interface LanguageSelectProps {
//   onLanguageChange: (language: Language) => void;
//   language?: Language;
//   langView?: boolean;
//   supporedLanguages?: string[];
// }

// const LanguageSelect: React.FC<LanguageSelectProps> = ({
//   onLanguageChange,
//   language,
//   langView,
//   supporedLanguages,
// }: LanguageSelectProps) => {
//   const { userToken } = useUserContext();
//   const { data: languageList } = useFetchLanguages(userToken);
//   const [selectedValue, setSelectedValue] = useState<string>(
//     languageList ? languageList[0].code : "en_us"
//   );

//   const handleChange = (event: SelectChangeEvent) => {
//     const { value } = event.target;
//     setSelectedValue(value);
//     const selectedLanguage = languageList?.find(
//       (language) => language.code === value
//     );
//     if (selectedLanguage) {
//       onLanguageChange(selectedLanguage);
//     }
//   };

//   useEffect(() => {
//     if (language) {
//       setSelectedValue(language.code);
//     }
//   }, [language]);

//   const dropDownStyle = {
//     minWidth: 120,
//     margin: "16px 0 8px",

//     "&.language-view": {
//       width: "440px",
//     },
//   };

//   return (
//     <section className="textfield-custom">
//       <Box className={langView ? "language-view" : ""} sx={dropDownStyle}>
//         <FormControl fullWidth>
//           <Select value={selectedValue} onChange={handleChange}>
//             {languageList?.map((language) => (
//               <MenuItem
//                 key={language.code}
//                 value={language.code}
//                 disabled={supporedLanguages
//                   ? !supporedLanguages?.some(sLang => sLang === language.code)
//                   : false}
//               >
//                 {language.language}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Box>
//     </section>
//   );
// };

// export default LanguageSelect;
